import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Dashboard from '../views/Dashboard.vue'
import Menu from '../views/Menu.vue'
import Dinamica from '../views/Dinamica.vue'
import Resultado from '../views/Resultado.vue'
import MiCuenta from '../views/MiCuenta.vue'
import Participaciones from '../views/Participaciones.vue'
import LoginReportes from '../views/LoginReportes.vue'


import { auth } from '../firebase'
import TicketOk from '../views/TicketOk.vue'
import Premios from '../views/Premios.vue'
import TerminosYCondiciones from '../views/TerminosYCondiciones.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Dashboard',
        component: Participaciones,
        meta: {
            requiresAuth: true,
            requiresNoTicket: true
        }
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Participaciones,
        meta: {
            requiresAuth: true,
            requiresNoTicket: true
        }
    },
    {
        path: '/ticket-ok',
        name: 'Ticket',
        component: TicketOk,
        meta: {
            requiresAuth: true,
            requiresNoTicket: false
        }
    },
    // {
    //     path: '/premios',
    //     name: 'Premios',
    //     component: Premios,
    //     meta: {
    //         requiresAuth: false,
    //         requiresNoTicket: false
    //     }
    // },
    {
        path: '/menu',
        name: 'Menu',
        component: Menu,
        meta: {
            requiresAuth: true,
            requiresNoTicket: true
        }
    },
    // {
    //     path: '/dinamica',
    //     name: 'Dinamica',
    //     component: Dinamica,
    //     meta: {
    //         requiresAuth: true,
    //         requiresTicket: true
    //     }
    // },
    // {
    //     path: '/resultado',
    //     name: 'Resultado',
    //     component: Resultado,
    //     meta: {
    //         requiresAuth: true
    //     }
    // },
    // {
    //     path: '/mi-cuenta',
    //     name: 'Mi Cuenta',
    //     component: MiCuenta,
    //     meta: {
    //         requiresAuth: true
    //     }
    // },
    {
        path: '/mis-participaciones',
        name: 'Participaciones',
        component: Participaciones,
        meta: {
            requiresAuth: true,
            requiresNoTicket: false
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/Login.vue')
    },
    {
        path: '/sesion-cerrada',
        name: 'SesionCerrada',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/SesionCerrada.vue')
    },
    // {
    //     path: '/registro',
    //     name: 'Registro',
    //     component: () =>
    //         import ( /* webpackChunkName: "login" */ '../views/Registro.vue')
    // },
    {
        path: '/registro-completo',
        name: 'RegistroCompleto',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/RegistroCompleto.vue')
    },

    // {
    //     path: '/verificacion/:id/:codigo',
    //     name: 'Verificacion',
    //     component: () =>
    //         import ( /* webpackChunkName: "login" */ '../views/Verificacion.vue')
    // },
    {
        path: '/ganadores',
        name: 'Ganadores',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/Ganadores.vue')
    },
    {
        path: '/reportes',
        name: 'Reportes',
        component: LoginReportes,
    }, {
        path: '/reportes/informe',
        name: 'Informe',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/ReportesInforme.vue'),
        meta: {
            requiresAuthAdmin: true
        }
    }, {
        path: '/reportes/informe-completo',
        name: 'Informe',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/ReportesInformeCompleto.vue'),
        meta: {
            requiresAuthAdmin: true
        }
    }, {
        path: '/reportes/descarga',
        name: 'InformeDescarga',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/ReportesDescarga.vue'),
        meta: {
            requiresAuthAdmin: true
        }
    },

    // {
    //     path: '/terminos-y-condiciones',
    //     name: 'terminos',
    //     component: TerminosYCondiciones
    // }
]

const router = new VueRouter({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    base: process.env.BASE_URL,
    routes
})

router.afterEach((to) => {
    // Meta Pixel
    if (window.fbq) {
        window.fbq('track', 'PageView');
    }

    // TikTok Pixel
    if (window.ttq && typeof window.ttq.page === 'function') {
        window.ttq.page();
    }

});



// navigation guard to check for logged in users
router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
    const requiresAuthAdmin = to.matched.some(x => x.meta.requiresAuthAdmin)

    const requiresNoTicket = to.matched.some(x => x.meta.requiresNoTicket)
    const requiresTicket = to.matched.some(x => x.meta.requiresTicket)

    if (requiresAuthAdmin === true && auth.currentUser != null && auth.currentUser.uid === 'Y9UqLIcwufNfyqJcEimgBEvkPLP2') {
        next()
    } else if (requiresAuthAdmin === true) {
        next('/login')
    } else if (requiresAuth && !auth.currentUser) {
        next('/login')
    } else {

        if (auth.currentUser != null && auth.currentUser.uid === 'Y9UqLIcwufNfyqJcEimgBEvkPLP2' && from.path != '/reportes/informe') {
            next('/reportes/informe')
        }

        // if (requiresNoTicket === true) {
        //     if (localStorage.getItem('id_ultimo_ticket_cementosraspa') != null && localStorage.getItem('id_ultimo_ticket_cementosraspa') != '') {
        //         next('/dinamica')
        //         return
        //     }
        // } else if (requiresTicket === true) {
        //     if (localStorage.getItem('id_ultimo_ticket_cementosraspa') == null || localStorage.getItem('id_ultimo_ticket_cementosraspa') == '') {
        //         next('/')
        //         return
        //     }
        // }

        next()

    }
})

export default router